<template>
  <div>
    <v-card class="mb-2" :color="$vuetify.theme.dark ? '#172233' : '#f2f7fb'" flat tile>
      <v-card-title class="small-title">Select Account Type</v-card-title>
      <ul class="chips small-chips">
        <li v-for="item in allAccountTypes" :key="item.id" :class="{ 'border-color': isCheckBox[item.id] }"
          @click="toggleCheckbox(item.id)">
          <input v-show="isCheckBox[item.id]" class="custom-checkbox custom-checkbox-small" type="checkbox"
            v-model="isCheckBox[item.id]" />
          {{ item.account_type_display }}
        </li>
      </ul>
    </v-card>
    <v-card-subtitle class="x-small-title px-0">
      At First Select Parent IB Then Select Acc. Type. After Selecting Both
      Click This Button
    </v-card-subtitle>
    <v-btn v-if="$canRoute('assign-account-type') === 1" :ripple="false" tile elevation="0" block class="custom-btn" :color="isButtonActive ? '#039de9' : '#647E98'"
      :disabled="!isButtonActive" large @click="handleAssignClick">
      Assign Acc. Type
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ASSIGNACCTYPE__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  name: 'AccountTypeChips',
  props: {
    selectedPartners: {
      type: Array,
      default: () => []
    },
    allAccountTypes: {
      type: Array,
      required: true,
      default: () => []
    },
    isCheckedAny: {
      type: Boolean,
    },
  },
  data() {
    return {
      isCheckBox: {}
    };
  },
  computed: {
    isButtonActive() {
      return Object.values(this.isCheckBox).some(value => value) && this.isCheckedAny;
    }
  },
  methods: {
    ...mapActions("assignacctype", [
      ASSIGNACCTYPE__ACTIONS.ASSIGNACCTYPE
    ]),
    toggleCheckbox(id) {
      this.$set(this.isCheckBox, id, !this.isCheckBox[id]);
      const selectedType = this.allAccountTypes.find(type => type.id === id);
      this.$emit('chip-selected', {
        id,
        value: this.isCheckBox[id],
        accountType: selectedType
      });
    },
    handleAssignClick() {
      if (this.isButtonActive) {
        const selectedTypes = this.allAccountTypes.filter(type => this.isCheckBox[type.id]);
        const parameter = {
          partners: this.selectedPartners ? this.selectedPartners?.map(item => item?.id) : [],
          account_types: selectedTypes ? selectedTypes?.map(item => item?.id) : []
        }
        this[ASSIGNACCTYPE__ACTIONS.ASSIGNACCTYPE](parameter)
      }
    },
    initializeCheckboxes() {
      const checkboxState = {};
      this.allAccountTypes.forEach(type => {
        checkboxState[type.id] = false;
      });
      this.isCheckBox = checkboxState;
    }
  },
  created() {
    this.initializeCheckboxes();
  },
  watch: {
    allAccountTypes: {
      handler() {
        this.initializeCheckboxes();
      },
      deep: true
    }
  }
};
</script>